<ng-container *ngIf="readonly; else editable">
  <ul *ngIf="fields?.length" class="custom-fields-readonly" data-test="customFieldsReadonly">
    <li *ngFor="let field of fields" class="text-sm py-1">
      <span class="grey-700">
        <span class="font-medium">{{ fieldName(field) || (field.type ? (('customField.' + field.type) | translate) : '') }}<mat-icon *ngIf="archivedTooltip(field) as tooltip" svgIcon="archive" class="archived-icon" [matTooltip]="tooltip | translate" data-test="customFieldArchived"></mat-icon>:</span>
        <ng-container [ngSwitch]="field.dataType">
          <ng-container *ngSwitchCase="DATA_TYPE.Boolean"><ng-container *ngIf="field.value">{{ ('customField.' + field.value) | translate }}</ng-container></ng-container>
          <ng-container *ngSwitchCase="DATA_TYPE.Date">{{ field.value | date: 'shortDate' }}</ng-container>
          <ng-container *ngSwitchCase="DATA_TYPE.Select">{{ selectLabel(field) }}</ng-container>
          <ng-container *ngSwitchDefault>{{ field.value }}</ng-container>
        </ng-container>
      </span>
    </li>
  </ul>
</ng-container>

<ng-template #editable>
  <div *ngFor="let customField of (form.controls | cast); let i = index" class="custom-field-row flex flex-col w-full" data-test="customFieldRow">
    <ng-container *ngIf="isFreeField(customField) && isEditingName(customField); else fieldLabel">
      <mat-label class="label field-label mb-1" [ngClass]="{'text-disabled' : customField.disabled}">{{'customField.name' | translate}}</mat-label>
      <div class="flex">
        <app-input class="name-input flex-1 min-w-0" [type]="'text'" [control]="customField.get('name')" [placeholder]="'customField.name' | translate" (keydown.enter)="$event.preventDefault(); confirmName(customField)" data-test="customFieldName"></app-input>
        <div class="row-actions">
          <button mat-icon-button type="button" class="icon-button" [disabled]="customField.disabled" (click)="confirmName(customField)" [matTooltip]="'customField.confirmName' | translate" data-test="customFieldConfirmName">
            <mat-icon svgIcon="check" color="primary"></mat-icon>
          </button>
          <ng-container *ngTemplateOutlet="dataTypeIcon; context: { $implicit: customField }"></ng-container>
        </div>
      </div>
      <mat-label class="label field-label mb-1" [ngClass]="{'text-disabled' : customField.disabled}">{{'customField.value' | translate}}</mat-label>
    </ng-container>
    <ng-template #fieldLabel>
      <div class="field-label label-row flex items-center min-w-0 mb-1" data-test="customFieldLabel">
        <span class="label truncate" [ngClass]="{'text-disabled' : customField.disabled}" [matTooltip]="definitionOf(customField)?.key || ''" data-test="customFieldLabelText">{{ rowLabel(customField).translate ? (rowLabel(customField).text | translate) : rowLabel(customField).text }}</span>
        <mat-icon *ngIf="archivedTooltip(customField) as tooltip" svgIcon="archive" class="archived-icon" [matTooltip]="tooltip | translate" data-test="customFieldArchived"></mat-icon>
        <button *ngIf="isFreeField(customField)" mat-icon-button type="button" class="icon-button" [disabled]="customField.disabled" (click)="editName(customField)" [matTooltip]="'customField.editName' | translate" data-test="customFieldEditName">
          <mat-icon svgIcon="edit-2" color="primary"></mat-icon>
        </button>
        <ng-container *ngTemplateOutlet="dataTypeIcon; context: { $implicit: customField }"></ng-container>
        <button *ngIf="canSaveAsDefinition(customField)" mat-icon-button type="button" class="icon-button on-hover" (click)="saveAsDefinition(customField)" [matTooltip]="'customFieldDefinitions.saveAsDefinition' | translate" data-test="customFieldSaveAsDefinition">
          <mat-icon svgIcon="save" color="primary"></mat-icon>
        </button>
      </div>
    </ng-template>

    <div class="flex items-start w-full">
      <div class="flex-1 min-w-0" [ngSwitch]="dataTypeOf(customField)">
        <app-input *ngSwitchCase="DATA_TYPE.Number" [type]="'number'" [decimals]="numberDecimals" [isNegativeAllowed]="true" [control]="customField.get('value')" [placeholder]="'customField.value' | translate" data-test="customFieldValue"></app-input>

        <div *ngSwitchCase="DATA_TYPE.Date" class="flex flex-col">
          <mat-form-field [class.mat-form-field-invalid]="customField.get('value')?.invalid && customField.get('value')?.touched">
            <input #dateInput class="datepicker-h" matInput [matDatepicker]="datepicker" [value]="datepickerValue(customField)" [disabled]="customField.disabled" (dateChange)="setDateValue(customField, $event.value, dateInput.value)" (blur)="customField.get('value')?.markAsTouched()" [placeholder]="'customField.value' | translate" data-test="customFieldValue">
            <mat-datepicker-toggle matSuffix [for]="datepicker">
              <mat-icon matDatepickerToggleIcon svgIcon="calendar" color="primary" class="mr-3" [ngClass]="{'text-disabled' : customField.disabled}"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
          </mat-form-field>
          <app-control-error [control]="customField.get('value')"></app-control-error>
        </div>

        <mat-slide-toggle *ngSwitchCase="DATA_TYPE.Boolean" [checked]="customField.get('value')?.value === 'true'" [disabled]="customField.disabled" (change)="setValue(customField, $event.checked)" class="boolean-value" data-test="customFieldValue"></mat-slide-toggle>

        <ng-container *ngSwitchCase="DATA_TYPE.Select">
          <div *ngIf="showsSelect(customField); else textValue" class="flex flex-col">
            <mat-form-field class="caption-c1">
              <mat-select [formControl]="customField.get('value')" [placeholder]="'organizationData.select' | translate" data-test="customFieldValue">
                <mat-option *ngFor="let option of fieldOptions(customField)" [value]="option.key" data-test="customFieldOption">
                  {{option.label}}<mat-icon *ngIf="option.archived" svgIcon="archive" class="archived-icon" [matTooltip]="'customFieldDefinitions.archivedOptionTooltip' | translate" data-test="customFieldOptionArchived"></mat-icon>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <app-control-error [control]="customField.get('value')"></app-control-error>
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="textValue"></ng-container>
        </ng-container>

        <ng-template #textValue>
          <app-input [type]="'text'" [control]="customField.get('value')" [placeholder]="'customField.value' | translate" data-test="customFieldValue"></app-input>
        </ng-template>
      </div>
      <div class="row-actions">
        <button mat-icon-button type="button" class="icon-button" (click)="deleteFormElement(form, i); form.markAsDirty()" [disabled]="form.disabled" [matTooltip]="'buttons.delete' | translate" data-test="customFieldDelete">
          <mat-icon svgIcon="trash" color="warn" [ngClass]="{'text-disabled' : form.disabled}"></mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-template #dataTypeIcon let-customField>
    <ng-container *ngIf="canChooseDataType(customField); else infoDataType">
      <button mat-icon-button type="button" class="icon-button" [matMenuTriggerFor]="dataTypeMenu" [disabled]="customField.disabled" [matTooltip]="('customField.dataTypes.' + dataTypeOf(customField)) | translate" data-test="customFieldDataType">
        <mat-icon [svgIcon]="DATA_TYPE_ICONS[dataTypeOf(customField)]" color="primary"></mat-icon>
      </button>
      <mat-menu #dataTypeMenu="matMenu">
        <button *ngFor="let dataType of freeDataTypes" mat-menu-item (click)="selectDataType(customField, dataType)" [attr.data-test]="'customFieldDataType-' + dataType">
          <mat-icon [svgIcon]="DATA_TYPE_ICONS[dataType]"></mat-icon>{{('customField.dataTypes.' + dataType) | translate}}
        </button>
      </mat-menu>
    </ng-container>
    <ng-template #infoDataType>
      <mat-icon class="data-type-icon" [svgIcon]="DATA_TYPE_ICONS[dataTypeOf(customField)]" [matTooltip]="('customField.dataTypes.' + dataTypeOf(customField)) | translate" data-test="customFieldDataTypeInfo"></mat-icon>
    </ng-template>
  </ng-template>

  <ng-container *ngIf="options.length || (scope && definitions.length); else newFreeField">
    <app-button-link [matMenuTriggerFor]="newFieldMenu" text="{{'buttons.newField' | translate}}" [disabled]="form.disabled" [style]="'primary'" iconLeft="plus-circle" data-test="customFieldAdd"></app-button-link>
    <mat-menu #newFieldMenu="matMenu">
      <button *ngFor="let option of options | sortTranslation: 'customField.'" mat-menu-item (click)="addPredefinedField(option)" data-test="customFieldAddPredefined">
        {{ ('customField.' + option) | translate }}
      </button>
      <button *ngFor="let definition of availableDefinitions" mat-menu-item (click)="addDefinitionField(definition)" data-test="customFieldAddDefinition">
        {{ definition.label }} <span class="caption-c2 secondary-text">· {{ ('customField.dataTypes.' + definition.dataType) | translate }}</span>
      </button>
      <button mat-menu-item (click)="addFreeField()" data-test="customFieldAddFree">{{'customFieldDefinitions.freeField' | translate}}</button>
    </mat-menu>
  </ng-container>
  <ng-template #newFreeField>
    <app-button-link (click)="addFreeField()" text="{{'buttons.newField' | translate}}" [disabled]="form.disabled" [style]="'primary'" iconLeft="plus-circle" data-test="customFieldAdd"></app-button-link>
  </ng-template>
</ng-template>
